import ApiClient from "../api/ApiClient";
import EndPoint from "../api/Endpoints";
import actionTypes from "../redux/action.types";

export const createQRCampaign = async (dispatch, data) => {
    try {
        dispatch({type: actionTypes.PROCESS_REQUEST, payload: {}});
        const response = await ApiClient.doPut(EndPoint.createQRCampaign, data);

        if (response.status) {
            dispatch({type: actionTypes.PROCESS_SUCCESS, payload: response});
            return response;
        } else {
            dispatch({type: actionTypes.PROCESS_FAILED, payload: response});
            return response;
        }
    } catch (error) {

        dispatch({type: actionTypes.PROCESS_ERROR, payload: {error: "ERROR: " + error}});
        return null;
    }
};

export const updateQRCampaign = async (dispatch, data) => {
    try {
        dispatch({type: actionTypes.PROCESS_REQUEST, payload: {}});
        const response = await ApiClient.doPut(EndPoint.updateQRCampaign, data);

        if (response.status) {
            dispatch({type: actionTypes.PROCESS_SUCCESS, payload: response});
            return response;
        } else {
            dispatch({type: actionTypes.PROCESS_FAILED, payload: response});
            return response;
        }
    } catch (error) {

        dispatch({type: actionTypes.PROCESS_ERROR, payload: {error: "ERROR: " + error}});
        return null;
    }
};

export const deleteQRCampaign = async (dispatch, data) => {
    try {
        dispatch({type: actionTypes.PROCESS_REQUEST, payload: {}});
        const response = await ApiClient.doPut(EndPoint.deleteQRCampaign, data);

        if (response.status) {
            dispatch({type: actionTypes.PROCESS_SUCCESS, payload: response});
            return response;
        } else {
            dispatch({type: actionTypes.PROCESS_FAILED, payload: response});
            return response;
        }
    } catch (error) {

        dispatch({type: actionTypes.PROCESS_ERROR, payload: {error: "ERROR: " + error}});
        return null;
    }
};

export const getAllQRCampaigns = async (dispatch, data = {}) => {
    try {
        dispatch({type: actionTypes.PROCESS_REQUEST, payload: {}});
        const response = await ApiClient.doPost(EndPoint.getAllQRCampaigns, data);

        if (response.status) {
            dispatch({type: actionTypes.PROCESS_SUCCESS, payload: response});
            return response;
        } else {
            dispatch({type: actionTypes.PROCESS_FAILED, payload: response});
            return response;
        }
    } catch (error) {

        dispatch({type: actionTypes.PROCESS_ERROR, payload: {error: "ERROR: " + error}});
        return null;
    }
};

export const getSingleQRCampaign = async (dispatch, data) => {
    try {
        dispatch({type: actionTypes.PROCESS_REQUEST, payload: {}});
        const response = await ApiClient.doPost(EndPoint.getSingleQRCampaign, data);

        if (response.status) {
            dispatch({type: actionTypes.PROCESS_SUCCESS, payload: response});
            return response;
        } else {
            dispatch({type: actionTypes.PROCESS_FAILED, payload: response});
            return response;
        }
    } catch (error) {

        dispatch({type: actionTypes.PROCESS_ERROR, payload: {error: "ERROR: " + error}});
        return null;
    }
};

export const getQRCampaignStats = async (dispatch, data = {}) => {
    try {
        dispatch({type: actionTypes.PROCESS_REQUEST, payload: {}});
        const response = await ApiClient.doPost(EndPoint.getQRCampaignStats, data);

        if (response.status) {
            dispatch({type: actionTypes.PROCESS_SUCCESS, payload: response});
            return response;
        } else {
            dispatch({type: actionTypes.PROCESS_FAILED, payload: response});
            return response;
        }
    } catch (error) {

        dispatch({type: actionTypes.PROCESS_ERROR, payload: {error: "ERROR: " + error}});
        return null;
    }
};